import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";
import { WkoLoadingSpinner } from "../WkoLoadingSpinner";
DataTable.use(DT);
const formatDate = (value, reviewerName) => {
    if (!value) {
        return reviewerName;
    }
    const formattedDate = new Date(value).toLocaleDateString();
    return reviewerName ? `${formattedDate} (${reviewerName})` : formattedDate;
};
export const buildNcReviewUrl = (vessel, showAcknowledged, search) => {
    const searchParams = new URLSearchParams(search);
    searchParams.set("selectedVesselId", String(vessel.VesselId));
    if (showAcknowledged) {
        searchParams.set("showAcknowledged", "true");
    }
    else {
        searchParams.delete("showAcknowledged");
    }
    return `/Home/NcReview?${searchParams.toString()}`;
};
export const NcReviewVesselListTable = ({ rows, title, tableId, emptyTableText = "No vessels found", showNcCount = true, loading = false, onOpenVessel, }) => {
    const columns = useMemo(() => showNcCount
        ? [
            { data: null, orderable: false, searchable: false },
            { data: "Vessel", width: "40%" },
            { data: "LastNcReviewDate" },
            { data: "LastVesselUpdate" },
            { data: "NumberOfNcsToReview" },
        ]
        : [
            { data: null, orderable: false, searchable: false },
            { data: "Vessel", width: "40%" },
            { data: "LastNcReviewDate" },
            { data: "LastVesselUpdate" },
        ], [showNcCount]);
    const slots = useMemo(() => {
        const baseSlots = {
            0: () => _jsx(_Fragment, {}),
            2: (data, type, row) => type === "sort" ? data : formatDate(data, row.LatestReviewer ?? "no review"),
            3: (data, type) => (type === "sort" ? data : formatDate(data, "no vessel update")),
        };
        if (showNcCount) {
            baseSlots[4] = (data) => (data == null || data === 0 ? "" : data);
        }
        return baseSlots;
    }, [showNcCount]);
    const tableOptions = useMemo(() => ({
        info: false,
        language: {
            emptyTable: emptyTableText,
            paginate: {
                previous: "Previous",
                next: "Next",
            },
        },
        pageLength: 10,
        lengthMenu: [10, 20, 50, 100],
        pagingType: "simple_numbers",
        searching: true,
        order: [[1, "asc"]],
        columnDefs: showNcCount
            ? [
                {
                    targets: 4,
                    className: "dt-head-left",
                },
            ]
            : [],
        createdRow: (row, data) => {
            row.style.cursor = "pointer";
            row.onclick = () => onOpenVessel(data);
        },
    }), [emptyTableText, onOpenVessel, showNcCount]);
    return (_jsx(_Fragment, { children: loading ? (_jsx("div", { className: "d-flex justify-content-center py-5", children: _jsx(WkoLoadingSpinner, {}) })) : (_jsxs("div", { children: [_jsx("h3", { children: title }), _jsx(DataTable, { id: tableId, data: rows, columns: columns, slots: slots, className: "table table-sm table-hover align-middle w-100", options: tableOptions, children: _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", {}), _jsx("th", { children: "Vessel" }), _jsx("th", { children: "Last NC Review Date" }), _jsx("th", { children: "Last Vessel Update" }), showNcCount ? _jsx("th", { children: "No. of NCs to Review" }) : null] }) }) })] })) }));
};
